import { useDebounceFn } from '@umijs/hooks';

import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useGettingScreenShot = () => {
  const { onSubmit: handleGetScreenshot } = useFetch(
    'device-screenshot-request',
    Api.DEVICE_SCREENSHOT
  );
  const { response: deviceScreenshot = {}, onFetch } = useFetch(
    'device-screenshot',
    Api.DEVICE_SCREENSHOT
  );

  const { run: onGetScreenshot } = useDebounceFn(
    (id) =>
      handleGetScreenshot({
        method: 'POST',
        pathParams: { id },
        onSuccess: () => {
          onFetch({ pathParams: { id } });
        },
      }),
    [],
    300
  );

  const onFetchScreenshot = (id) => onFetch({ pathParams: { id } });

  return {
    deviceScreenshot,
    onGetScreenshot,
    onFetchScreenshot,
  };
};

export default useGettingScreenShot;
